export const formatScore = (score: number): string => {
  if (Number.isNaN(score)) return "0";
  return Number.isInteger(score) ? score.toString() : score.toFixed(2);
};
